module.exports = __webpack_public_path__ + "img/logo-colour.9c77b260.svg";